module.exports = __webpack_public_path__ + "img/step_4.d52cf9d2.png";